import { AUDIT_REPORT_URL } from "@/types/home";
import { LayoutSectionCard } from "@/ui/Components/LayoutSectionCard";
import { Flex, Link, Text, Image, useColorModeValue } from "@chakra-ui/react";
import type { FC } from "react";

export const Auditors: FC = () => {
  return (
    <LayoutSectionCard
      flexDirection="column"
      gap="60px"
      position="relative"
      zIndex={2}
      backgroundContent={
        <Image
          mx="auto"
          width="100%"
          height="100%"
          src={`/images/${useColorModeValue("auditor-decor-light", "auditor-decor")}.png`}
          alt="auditor"
          position="absolute"
          bottom="-118px"
          display={{ base: "none", lg: "block" }}
          zIndex={1}
        />
      }
    >
      <Flex flexDirection="column">
        <Text size="5xl" textAlign="center">
          Auditors
        </Text>
      </Flex>
      <Flex flexDirection="column" gap="32px">
        <Link
          href="https://www.certik.com/"
          target="_blank"
          className="mx-auto"
        >
          <Image
            mx="auto"
            height="auto"
            src="/images/auditor.png"
            alt="auditor"
            className="w-[632px] h-auto mx-auto"
            width={{ base: "full", lg: "632px" }}
            border="2px solid"
            borderColor="neutral.stroke.light"
            boxShadow="0px 12px 32px 0px rgba(0, 0, 0, 0.12)"
            borderRadius="20px"
          />
        </Link>
        <Text size="xl" textAlign="center" maxW="632px" mx="auto">
           Verichain, a leading blockchain security firm, has thoroughly audited {`Pit's`} smart contracts. Published on Sep 12, 2024, the audit confirms the contracts strong security and reliability.{" "}
          <Link href={AUDIT_REPORT_URL} textDecor="underline" target="_blank">
            Read the full report
          </Link>{" "}
          for complete details.
        </Text>
      </Flex>
    </LayoutSectionCard>
  );
};
